import angular from "angular";
import CostModalPricingComponent from "./cost-modal-pricing/cost-modal-pricing";
import DateComponent from "./date/date";
import FontSelectorComponent from "./font-selector/font-selector";
import FontSizeSelectorComponent from "./font-size-selector/font-size-selector";
import FontStyleChangerComponent from "./font-style-changer/font-style-changer";
import ImageSelectorComponent from "./image-selector/image-selector";
import NavbarOverQuoteComponent from "./navbar-over-quote/navbar-over-quote";
import PricingTableComponent from "./pricing-table/pricing-table";
import PricingTablePreviewComponent from "./pricing-table-preview/pricing-table-preview";
import QuoteActivityComponent from "./quote-activity/quote-activity";
import QuoteEditComponent from "./quote-edit/quote-edit";
import QuoteEditorPageComponent from "./quote-editor-page/quote-editor-page.component";
import QuoteNewSectionComponent from "./quote-new-section/quote-new-section";
import QuoteNewSectionAnimation from "./quote-new-section/quote-new-section.animation";
import QuoteSectionComponent from "./quote-section/quote-section";
import QuoteSectionNameFormComponent from "./quote-section-name-form/quote-section-name-form";
import QuoteTemplateNameFormComponent from "./quote-template-name-form/quote-template-name-form";
import SectionBackgroundSelectorComponent from "./section-background-selector/section-background-selector";
import TinyMceComponent from "./tiny-mce/tiny-mce";
import PlaceholderModalComponent from "./placeholder-modal/placeholder-modal";
import PricingTableModalComponent from "./pricing-table-modal/pricing-table-modal";
import QuoteHeaderModalComponent from "./quote-header-modal/quote-header-modal";
import QuoteSectionNameModalComponent from "./quote-section-name-modal/quote-section-name-modal";
import QuoteShareModalComponent from "./quote-share-modal/quote-share-modal";
import QuoteTemplateCreateOverwriteModalComponent from "./quote-template-create-overwrite-modal/quote-template-create-overwrite-modal";
import SectionGalleryModalComponent from "./section-gallery-modal/section-gallery-modal";
import ImageSelectorModalComponent from "./image-selector-modal/image-selector-modal";

const QuoteEditorModule = angular
  .module("modules.quoteEditor", [])
  .component("costModalPricing", CostModalPricingComponent)
  .component("date", DateComponent)
  .component("fontSelector", FontSelectorComponent)
  .component("fontSizeSelector", FontSizeSelectorComponent)
  .component("fontStyleChanger", FontStyleChangerComponent)
  .component("imageSelector", ImageSelectorComponent)
  .component("imageSelectorModal", ImageSelectorModalComponent)
  .component("navbarOverQuote", NavbarOverQuoteComponent)
  .component("placeholderModal", PlaceholderModalComponent)
  .component("pricingTable", PricingTableComponent)
  .component("pricingTableModal", PricingTableModalComponent)
  .component("pricingTablePreview", PricingTablePreviewComponent)
  .component("quoteActivity", QuoteActivityComponent)
  .component("quoteEdit", QuoteEditComponent)
  .component("quoteEditorPage", QuoteEditorPageComponent)
  .component("quoteHeaderModal", QuoteHeaderModalComponent)
  .component("quoteNewSection", QuoteNewSectionComponent)
  .component("quoteSection", QuoteSectionComponent)
  .component("quoteSectionNameForm", QuoteSectionNameFormComponent)
  .component("quoteSectionNameModal", QuoteSectionNameModalComponent)
  .component("quoteShareModal", QuoteShareModalComponent)
  .component("quoteTemplateNameForm", QuoteTemplateNameFormComponent)
  .component("quoteTemplateCreateOverwriteModal", QuoteTemplateCreateOverwriteModalComponent)
  .component("sectionBackgroundSelector", SectionBackgroundSelectorComponent)
  .component("sectionGalleryModal", SectionGalleryModalComponent)
  .component("tinyMce", TinyMceComponent)
  .animation(".quote-new-section", QuoteNewSectionAnimation);

export default QuoteEditorModule;
